/* eslint-disable default-param-last */
/* eslint-disable no-case-declarations */
import { Reducer } from 'redux';
import produce from 'immer';

import { DrLicitaTypes, DrLicitaState } from './types';

const INITIAL_STATE: DrLicitaState = {
  documents: [],
  document_types: [],
  law_types: [],
  documents_request: {
    loaded: false,
    loading: false,
    error: false,
  },
  delete_documents_request: {
    loaded: false,
    loading: false,
    error: false,
  },
  document_types_request: {
    loaded: false,
    loading: false,
    error: false,
  },
  law_types_request: {
    loaded: false,
    loading: false,
    error: false,
  },
};

// eslint-disable-next-line no-unused-vars
const reducer: Reducer<DrLicitaState> = (state = INITIAL_STATE, { type, result, documentId }) => {
  // eslint-disable-next-line no-unused-vars
  return produce(state, (draft) => {
    switch (type) {
      case DrLicitaTypes.GET_DOCUMENTS_REQUEST:
        draft.documents_request.loaded = false;
        draft.documents_request.loading = true;
        draft.documents_request.error = false;
        break;

      case DrLicitaTypes.GET_DOCUMENTS_SUCCESS:
        draft.documents = result.data.documents;

        draft.documents_request.loaded = true;
        draft.documents_request.loading = false;
        draft.documents_request.error = false;
        break;

      case DrLicitaTypes.GET_DOCUMENTS_FAILURE:
        draft.documents_request.loaded = false;
        draft.documents_request.loading = false;
        draft.documents_request.error = true;
        break;

      case DrLicitaTypes.GET_DOCUMENT_TYPES_REQUEST:
        draft.document_types_request.loaded = false;
        draft.document_types_request.loading = true;
        draft.document_types_request.error = false;
        break;

      case DrLicitaTypes.GET_DOCUMENT_TYPES_SUCCESS:
        draft.document_types = result.data.documents_types;

        draft.document_types_request.loaded = true;
        draft.document_types_request.loading = false;
        draft.document_types_request.error = false;
        break;

      case DrLicitaTypes.GET_DOCUMENT_TYPES_FAILURE:
        draft.document_types_request.loaded = false;
        draft.document_types_request.loading = false;
        draft.document_types_request.error = true;
        break;

      case DrLicitaTypes.GET_LAW_TYPES_REQUEST:
        draft.law_types_request.loaded = false;
        draft.law_types_request.loading = true;
        draft.law_types_request.error = false;
        break;

      case DrLicitaTypes.GET_LAW_TYPES_SUCCESS:
        draft.law_types = result.data.laws_types;

        draft.law_types_request.loaded = true;
        draft.law_types_request.loading = false;
        draft.law_types_request.error = false;
        break;

      case DrLicitaTypes.GET_LAW_TYPES_FAILURE:
        draft.law_types_request.loaded = false;
        draft.law_types_request.loading = false;
        draft.law_types_request.error = true;
        break;

      case DrLicitaTypes.DELETE_DOCUMENT_REQUEST:
        draft.delete_documents_request.loaded = false;
        draft.delete_documents_request.loading = true;
        draft.delete_documents_request.error = false;
        break;

      case DrLicitaTypes.DELETE_DOCUMENT_SUCCESS:
        draft.documents = draft.documents.filter((document) => document.id !== documentId);

        draft.delete_documents_request.loaded = true;
        draft.delete_documents_request.loading = false;
        draft.delete_documents_request.error = false;
        break;

      case DrLicitaTypes.DELETE_DOCUMENT_FAILURE:
        draft.delete_documents_request.loaded = false;
        draft.delete_documents_request.loading = false;
        draft.delete_documents_request.error = true;
        break;

      default:
        break;
    }
  });
};

export default reducer;
